import { ViewModel,View, ObservableArray } from "binder"
import { AttachedProperty, FormBuilderComponent } from "src/formBuilder/structure/components";
import { ChildAcceptableFormBuilderElement, FormBuilderElement, IFormBuilderElementVisitor } from "src/formBuilder/structure/element";
import { IntegerPropertyType, StringPropertyType } from "src/formBuilder/structure/propertyTypes/propetyTypes";
import  { GridView } from "./grid-view"
import { GridLocationDecoratorViewModel } from "./gridLocationDecorator/gridLocationDecorator-viewModel";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { GridLocationSpecifierViewModel } from "./gridLocationSpecifier/gridLocationSpecifier-viewModel";


export class GridComponent extends FormBuilderComponent{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.name = 'Grid';
        this.canAcceptContent = true;
        this.canAcceptMultipleContent = true;

        this.addProperty("ColumnDefinition","data-b-comp-columndefinition",new StringPropertyType(this),"",false);
        this.addProperty("RowDefinition","data-b-comp-rowdefinition",new StringPropertyType(this),"",false);

        this.addAttachedProperty("GridAttachedColumn","data-b-attach-column",new IntegerPropertyType(this),"1");
        this.addAttachedProperty("GridAttachedRow","data-b-attach-row",new IntegerPropertyType(this),"1");
        this.addAttachedProperty("GridAttahedColumnSpan","data-b-attach-columnspan",new IntegerPropertyType(this),"1");
        this.addAttachedProperty("GridAttachedRowSpan","data-b-attach-rowspan",new IntegerPropertyType(this),"1");

    }
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}

    CreateInternal(parent:ViewModel):FormBuilderElement{
        let result = new GridViewModel(parent);

        return result;
    }
}

export class GridViewModel extends ChildAcceptableFormBuilderElement{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.locationSpecifiers = ObservableArray.create<GridLocationSpecifierViewModel>();
    }
    GetDefaultView(): View <ViewModel> {
        return new GridView();
    }
    public getTypeId(): string {
        return "VM-B4C43633-14C2-4507-B3F0-D773125FAA09"
    }

    public set ColumnDefinition(v: string) { 
        this._ColumnDefinition = v; 
        this.updateLocationSpecifiers();
    } public get ColumnDefinition(): string { return this._ColumnDefinition;} private _ColumnDefinition: string;
    public set RowDefinition(v: string) { 
        this._RowDefinition = v; 
        this.updateLocationSpecifiers();
    } public get RowDefinition(): string { return this._RowDefinition;} private _RowDefinition: string;
    public set locationSpecifiers(v: ObservableArray<GridLocationSpecifierViewModel>) { this._locationSpecifiers = v; } public get locationSpecifiers(): ObservableArray<GridLocationSpecifierViewModel> { return this._locationSpecifiers;} private _locationSpecifiers: ObservableArray<GridLocationSpecifierViewModel>;
    
    updateLocationSpecifiers(){
        var columnCount = stringIsNullOrEmpty(this.ColumnDefinition) ? 1 : this.ColumnDefinition.split(' ').filter(x=>stringIsNullOrEmpty(x)==false).length;
        var rowCount = stringIsNullOrEmpty(this.RowDefinition) ? 1 : this.RowDefinition.split(' ').filter(x=>stringIsNullOrEmpty(x)==false).length;
        if(columnCount==0) columnCount=1;
        if(rowCount==0) rowCount=1;
        let children = [];
        for(let i=0;i<columnCount;i++){
            for(let j=0;j<rowCount;j++){
                let locationSpecifier = new GridLocationSpecifierViewModel(this);
                locationSpecifier.column = i+1;
                locationSpecifier.row = j+1;
                children.push(locationSpecifier);
            }
        }
        this.locationSpecifiers.update(...children);
    }

    Accept(visitor: IFormBuilderElementVisitor, parameter: object): object {
        return visitor.VisitGrid(this,parameter);
    }
    findRelatedLocationSpecifier(mouseEvent?:MouseEvent) : GridLocationSpecifierViewModel{
        return this.locationSpecifiers.filter(x=>x.IsMourseOver(mouseEvent.clientX,mouseEvent.clientY)).at(0);
    }
    addChildInternal(element: FormBuilderElement,mouseEvent?:MouseEvent): void {
        
        if(element){
            let specifier:GridLocationSpecifierViewModel = null;
            element.DataContext = this.DataContext;
            if(mouseEvent){
                specifier = this.findRelatedLocationSpecifier(mouseEvent);
            }
            let decorator = new GridLocationDecoratorViewModel(this);
            decorator.decoratorComponent = element;
            element.parentViewModel = decorator;
            element.decoratorHead = <any>decorator;
            this.component.getProperties().filter(x=>x instanceof AttachedProperty==true).forEach(x=>{
                element.registerAttached(x,<FormBuilderElement><any>decorator);
                element.UnsetPropertyValue(x);
            });
            this.children.push(<any>decorator);
            if(specifier){
                element.findPropertyByName("GridAttachedColumn").setStaticValue(specifier.column);
                element.findPropertyByName("GridAttachedRow").setStaticValue(specifier.row);
            }
        }
    }
    removeChild(element: FormBuilderElement): void {
        let elementSelf = element.self;
        let toRemoveElement = this.children.filter(x=>x.self==elementSelf);
        if(toRemoveElement.length>0){
            let removingElement = <GridLocationDecoratorViewModel><any>(toRemoveElement[0]);
            this.component.getProperties().filter(x=>x instanceof AttachedProperty==true).forEach(x=>{
                element.unregisterAttacheds();
            });
            this.children.remove(<any>removingElement);
        }
    }
    
}
